import { render, staticRenderFns } from "./ManejoLiquidacionesComercio.vue?vue&type=template&id=5acd3d48"
import script from "./ManejoLiquidacionesComercio.vue?vue&type=script&lang=js"
export * from "./ManejoLiquidacionesComercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports